/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { Injectable } from '@angular/core';
import { StateUpdate } from '@app/data-model/state-update';
import { AppConfigService } from '@app/common/app-config.service';
import { CountUpdate } from '@app/data-model/count-update';
import { UserPrivilegesService } from '@app/common/user-privileges.service';

@Injectable({
  providedIn: 'root'
})
export class DataModelService {
  constructor(private appConfigService: AppConfigService, private userPrivilegesService: UserPrivilegesService) {}

  getCountUpdate(id, total, stat, vipTotal, vipStat, findings, vipFindings, byInstitute): CountUpdate {
    return new CountUpdate(
      {
        id,
        totalItemsCnt: total,
        totalVipItemsCnt: vipTotal,
        totalSTATCnt: stat,
        totalVipSTATCnt: vipStat,
        totalAiFindingCnt: findings,
        totalAiFindingVipCnt: vipFindings,
        byInstitute: byInstitute
      },
      this.userPrivilegesService.hasPrivilege('ViewConfidentialPatient'),
      Array.isArray(this.userPrivilegesService.institutes) ? this.userPrivilegesService.institutes : [],
      this.appConfigService.isInstituteSeparationEnabled()
    );
  }

  getStateUpdate(id, newState) {
    return new StateUpdate(id, newState, this.appConfigService.getUserId());
  }
}
